import Quill from "quill";

const Embed = Quill.import("blots/embed");

// Single-instance token keys (must match client/src/utils/tokenUniquity.js UNIQUE_TOKEN_KEYS)
const UNIQUE_TOKEN_KEYS = [
  "invoice.items_table", "invoice.line_items",
  "estimate.items_table", "estimate.line_items",
  "invoice.totals_section", "totals_section",
  "invoice.notes_section", "notes_section",
  "invoice.company_logo", "company_logo",
];

class MergeTokenBlot extends Embed {
  static blotName = "mergeToken";
  static tagName = "SPAN";
  static className = "merge-token";

  static create(value) {
    // value = { key: "client.name", token: "[Client.Name]" }
    const node = super.create();
    node.setAttribute("contenteditable", "false");
    node.setAttribute("data-key", value.key);
    node.setAttribute("data-token", value.token);
    node.setAttribute("draggable", "true");
    node.classList.add("merge-token");

    const allowDuplicate = !UNIQUE_TOKEN_KEYS.includes(value.key);
    
    // Create inner structure with duplicate button (if allowed), label, and remove button
    node.innerHTML = `
      ${allowDuplicate ? `<span class="token-duplicate">+</span>` : ""}
      <span class="token-label">${value.token}</span>
      <span class="token-remove">×</span>
    `;
    
    return node;
  }

  static value(node) {
    return {
      key: node.getAttribute("data-key"),
      token: node.getAttribute("data-token")
    };
  }

  static register() {
    if (this._registered) return;
    Quill.register(this);
    this._registered = true;
  }
}

MergeTokenBlot.register();

export default MergeTokenBlot;
